import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3d7cd091"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-row space-x-3" }
const _hoisted_2 = { class: "flex flex-col w-2/3" }
const _hoisted_3 = { class: "grid grid-cols-1 gap-2 grid-rows-2 w-full" }
const _hoisted_4 = { class: "text-blue-600" }
const _hoisted_5 = { class: "text-blue-600" }
const _hoisted_6 = { class: "w-1/3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h-[250px] w-full bg-no-repeat bg-cover bg-center rounded-xl",
  style: {"background-image":"url(/media/icons/thumbnail-2-img.svg)"}
}, null, -1))
const _hoisted_8 = { class: "flex flex-col p-6 space-y-4 divide-[#11212c] divide-y" }
const _hoisted_9 = { class: "grid grid-cols-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400" }, "Type de véhicule", -1))
const _hoisted_11 = { class: "text-gray-200" }
const _hoisted_12 = { class: "grid grid-cols-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400" }, "Marque", -1))
const _hoisted_14 = { class: "text-gray-200" }
const _hoisted_15 = { class: "grid grid-cols-2" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400" }, "Modèle", -1))
const _hoisted_17 = { class: "text-gray-200" }
const _hoisted_18 = { class: "grid grid-cols-2" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400" }, "Numéro VIN", -1))
const _hoisted_20 = { class: "text-gray-200" }
const _hoisted_21 = { class: "grid grid-cols-2" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400" }, "Immatriculation", -1))
const _hoisted_23 = { class: "text-gray-200" }
const _hoisted_24 = { class: "grid grid-cols-2" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400" }, "Année de sortie", -1))
const _hoisted_26 = { class: "text-gray-200" }
const _hoisted_27 = { class: "grid grid-cols-2" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400" }, "Capacité réservoir", -1))
const _hoisted_29 = { class: "text-gray-200" }
const _hoisted_30 = { class: "grid grid-cols-2" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400" }, "Nombre de places", -1))
const _hoisted_32 = { class: "text-gray-200" }

import api from "@/api";
	import { ref, onMounted, inject } from "vue";
	import { formatDate } from "@/utils";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'VehicleDetail',
  setup(__props) {

	const isLoading = ref(false);
	const maintenanceHistoryData = ref([]);
	const selectedVehicleData: any = ref(inject("selectedVehicleData"));
	const technicalVisitsData = ref([]);
	const columnsMaintenanceHistory = ref<any>([
		{
			name: "status",
			label: "Prestataire",
			width: "15%",
		},
		{
			name: "label",
			label: "Date de maintenance",
			width: "20%",
		},
		{
			name: "date",
			label: "Kilométrage",
			width: "30%",
		},
		{
			name: "price",
			label: "Actions",
			width: "15%",
		},
	]);

	const columnsTechnicalVisits = ref<any>([
		{
			name: "status",
			label: "Prestataire",
			width: "5%",
		},
		{
			name: "label",
			label: "Date de maintenance",
			width: "20%",
		},
		{
			name: "date",
			label: "Montant",
			width: "12%",
		},
		{
			name: "price",
			label: "Expiration",
			width: "15%",
		},
	]);

return (_ctx: any,_cache: any) => {
  const _component_AppDatatable = _resolveComponent("AppDatatable")!
  const _component_CardWidget = _resolveComponent("CardWidget")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_CardWidget, {
        css: "h-full w-full",
        style: {"height":"calc(100vh - 17rem)"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_AppDatatable, {
              title: 'Historique des entretiens',
              options: {
							columns: columnsMaintenanceHistory.value,
							data: maintenanceHistoryData.value,
							isLoading: isLoading.value,
						},
              heightTable: "calc(100vh - 26rem)",
              emptyTagStyle: "!h-12",
              dynamicWidth: true,
              moreactions: {
							status: false,
							style: 'w-[8%]',
							stylerow: 'space-x-2',
						},
              styleHeader: "bg-[#182029]"
            }, {
              created_at: _withCtx((slotProps) => [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(formatDate)(slotProps.data.created_at)), 1)
              ]),
              _: 1
            }, 8, ["options"]),
            _createVNode(_component_AppDatatable, {
              title: 'Visites Techniaues',
              options: {
							columns: columnsTechnicalVisits.value,
							data: technicalVisitsData.value,
							isLoading: isLoading.value,
						},
              heightTable: "calc(100vh - 26rem)",
              emptyTagStyle: "!h-12",
              dynamicWidth: true,
              moreactions: {
							status: false,
							style: 'w-[8%]',
							stylerow: 'space-x-2',
						},
              styleHeader: "bg-[#182029]"
            }, {
              created_at: _withCtx((slotProps) => [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(formatDate)(slotProps.data.created_at)), 1)
              ]),
              _: 1
            }, 8, ["options"])
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_CardWidget, {
        css: "p-0 flex-col flex",
        style: {"height":"calc(100vh - 17rem)"}
      }, {
        default: _withCtx(() => [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, _toDisplayString(selectedVehicleData.value?.vehicle_type?.label || '—'), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, _toDisplayString(selectedVehicleData.value.mark_name), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, _toDisplayString(selectedVehicleData.value.model_no), 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, _toDisplayString(selectedVehicleData.value.vin_no), 1)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, _toDisplayString(selectedVehicleData.value.matriculation_no), 1)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, _toDisplayString(selectedVehicleData.value.buying_date), 1)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, _toDisplayString(selectedVehicleData.value.reservoir_capacity), 1)
            ]),
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("div", _hoisted_32, _toDisplayString(selectedVehicleData.value.place_number), 1)
            ])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})